import { Box, Heading, Text, VStack } from "@chakra-ui/react";
import QRCode from "qrcode.react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  adminModalBodyProps,
  adminModalContentProps,
  adminModalHeaderProps,
} from "../../../../components/Models/admin-modal-theme";
import MainModel from "../../../../components/Models/main-model";
import { closeUserQRCodeModel } from "../../../../modules/admin-modules/models/Actions";

const UserQRCode = ({ data }) => {
  const dispatch = useDispatch();
  const header = (
    <Box>
      <Heading
        textAlign="center"
        color="var(--text-primary)"
        fontSize="24px"
        fontWeight="800"
      >
        QR Code
      </Heading>
    </Box>
  );

  const openUserData = useSelector((state) => state.model.isOpen14);

  const closeFunc = () => {
    dispatch(closeUserQRCodeModel());
  };
  return (
    <MainModel
      header={header}
      closeFunc={closeFunc}
      openVar={openUserData}
      buttonTitle={null}
      buttonFunc={null}
      contentProps={adminModalContentProps}
      headerProps={adminModalHeaderProps}
      bodyProps={adminModalBodyProps}
    >
      <VStack spacing={1}>
        <Text
          my={2}
          textAlign="center"
          maxW="280px"
          fontWeight="700"
          color="var(--text-primary)"
        >
          {data?.subject?.name}
        </Text>
        <Text
          my={2}
          textAlign="center"
          maxW="280px"
          fontWeight="700"
          color="var(--text-primary)"
        >
          {data?.name}
        </Text>
        <Text
          my={2}
          textAlign="center"
          maxW="280px"
          fontWeight="700"
          color="var(--text-muted)"
        >
          {data?.user_name}
        </Text>
        <QRCode
          size={200}
          value={`https://edutopiaonline.com/scan-code/${data?.id}/attendence`}
        />
      </VStack>
    </MainModel>
  );
};

export default UserQRCode;
